import { useEffect, useState } from "react";
import { CommentSection } from "./CommentSection";
import { getAuthUser } from "../../utils/GetAuthUser";

// Helper function: build nested tree
const buildCommentsTree = (comments) => {
  const map = {};
  const roots = [];

  // Make each comment a map entry with replies
  comments.forEach((comment) => {
    map[comment.id] = { ...comment, replies: [] };
  });

  // Assign children
  comments.forEach((comment) => {
    if (comment.parentId) {
      // Only add as reply if parent exists in the map
      if (map[comment.parentId]) {
        map[comment.parentId]?.replies.push(map[comment.id]);
      } else {
        // If parent doesn't exist, treat as root comment
        roots.push(map[comment.id]);
      }
    } else {
      roots.push(map[comment.id]);
    }
  });

  return roots;
};

export const CommentCheck = ({comments, isLoading, onSaveComment, contestId, isSaving}) => {

  const [commentsData, setCommentsData] = useState([]);



  useEffect(() => {

    if (comments?.length) {
      const treeData = buildCommentsTree(comments);
      setCommentsData(treeData);
    } else {
      setCommentsData([]);
    }
  }, [comments]);

  const handleAddComment = (commentText) => {
    const authUser = getAuthUser();
    const commentData = {
      sender_id: authUser?.user?.id,
      contest_id: contestId,
      comment: commentText,
      parent_id: null
    };
    
    // Call the save function passed from parent
    onSaveComment(commentData);
  };


  const handleAddReply = (parentId, replyText) => {
    const authUser = getAuthUser();
    const commentData = {
      sender_id: authUser?.user?.id,
      contest_id: contestId,
      comment: replyText,
      parent_id: parentId
    };
    
    // Call the save function passed from parent
    onSaveComment(commentData);
  };

  return (
    <div className="w-full flex flex-col gap-5 ">
      {isLoading ? (
        <p>Loading comments...</p>
      ) : (
        <CommentSection
          comments={commentsData}
          onAddComment={handleAddComment}
          onAddReply={handleAddReply}
          isSaving={isSaving}
        />
      )}
    </div>
  );
};
